
























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";

const family = namespace("family");
@Component({ components: {} })
export default class selectFamily extends Vue {
  @family.Action queryFamilyList;

  visible: boolean = false;
  familyList = [];
  ruleForm = {
    family: ""
  };
  total = 0;
  pageNumber = 1;
  pageSize = 100;
  curFilter = "";

  @Watch("visible")
  onvisibleChange(val, oldVal) {
    if (val) {
      this.getList();
    } else {
      (this.$refs.ruleForm as any).resetFields();
    }
  }
  async getList() {
    let { list, total } = await this.queryFamilyList({
      condition: {
        conditionList: [[{ key: "familyName", value: this.curFilter, type: 4 }]]
      },
      pageInput: {
        pageNum: this.pageNumber,
        pageSize: this.pageSize
      }
    });
    this.familyList = [...this.familyList, ...list];
    this.total = total;
  }
  LoadMore() {
    if (this.total <= this.familyList.length) {
      return;
    }
    this.pageNumber++;
    this.getList();
  }
  searchFn(query) {
    this.curFilter = query;
    this.pageNumber = 1;
    this.familyList = [];
    this.getList();
  }
  visibleSelect(val) {
    if (!val && this.curFilter) {
      this.pageNumber = 1;
      this.curFilter = "";
      this.familyList = [];
      this.getList();
    }
  }
  handelSkip() {
    this.$router.push({ name: "ProductCreate" });
  }
  handleSubmit() {
    this.$router.push({
      name: "ProductCreate",
      query: { familyCode: this.ruleForm.family }
    });
  }
}
